import { render } from "./FAQPage.vue?vue&type=template&id=e1a4acb4&scoped=true"
import script from "./FAQPage.vue?vue&type=script&lang=js"
export * from "./FAQPage.vue?vue&type=script&lang=js"

import "./FAQPage.vue?vue&type=style&index=0&id=e1a4acb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a4acb4"]])

export default __exports__